export default __webpack_public_path__ + "static/media/image.rcs2-technologies-pvt-ltd.68bfc27f.png";